import React from 'react';
import { FilePlus2, Store } from 'lucide-react';

const TastingRoomInventoryToolbar = ({ 
    locations,
    selectedLocation,
    onLocationChange,
    onCreateLog,
    isCreating 
}) => {
    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="container-fluid py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <Store size={24} className="me-2" />
                        <h5 className="mb-0">Tasting Room Inventory</h5>
                    </div>
                    
                    <div className="d-flex align-items-center gap-3">
                        <select 
                            className="form-select" 
                            style={{ width: 'auto' }}
                            value={selectedLocation || ''}
                            onChange={(e) => onLocationChange(e.target.value)}
                        >
                            <option value="">Select Location</option>
                            {locations.map(location => (
                                <option key={location.locationID} value={location.locationID}>
                                    {location.locationName}
                                </option>
                            ))}
                        </select>

                        <button
                            className="btn btn-outline-primary"
                            onClick={onCreateLog}
                            disabled={isCreating || !selectedLocation}
                        >
                            <FilePlus2 size={18} className="me-2" />
                            {isCreating ? 'Creating...' : 'New Inventory Count'}
                        </button>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }

                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }

                .btn:active svg {
                    transform: scale(0.95);
                }
            `}</style>
        </div>
    );
};

export default TastingRoomInventoryToolbar;